import React from 'react';

import { ScreenLink } from '@gogame/screens';

import { trackerLink } from 'scenes/Trackers/Tracker/navigation';

const ScreenLinkToTracker = ({ children, params }) => (
  <ScreenLink
    link={trackerLink}
    target={'_blank'}
    params={{
      tableSettings: {
        orderBy: 'RegActions',
      },
      ready: true,
      columns: {
        order: [
          'RegActions',
          'PromoCodeAttributedRedeemers',
          'TotalDepositAmount',
          'TotalArpu',
          'TotalArppu',
        ],
      },
      charts: [
        {
          metrics: ['PromoCodeAttributedRedeemers'],
        },
      ],
      ...params,
    }}
  >
    {children}
  </ScreenLink>
);

export default ScreenLinkToTracker;
